import { type Application } from '~/utils'

import { NavigationContent } from './components/NavigationContent'
import { rootPath } from './routes/paths'
import { Root } from './routes/Root'

export const application: Application = {
  id: 'admin',
  name: 'Application Admin' as const,
  NavigationContent,
  Root,
  rootPath,
}
